<template>
    <div class="app-logout">
        <!--<a target="_blank" href="http://popo.netease.com/static/html/open_popo.html?ssid=grp.zhitu@corp.netease.com&sstp=0" class="popo-tools">-->
          <!--<img src="/img/popo.png"/>联系我们</a>-->
    <el-dropdown @command="onMenuClick" >
      <span class="app-login-name">
        <i class="iconfont icon-user"></i>{{user.name}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
            <el-dropdown-menu slot="dropdown" class="app-logout-dropdown">
                <el-dropdown-item command="user" v-if="isAdmin">成员管理</el-dropdown-item>
                <el-dropdown-item command="project" v-if="isProjectUser">添加项目</el-dropdown-item>
                <el-dropdown-item command="admin" v-if="isSYSAdmin || isProjectAdmin">后台管理</el-dropdown-item>
                <el-dropdown-item command="dataView" v-if="isAdmin">数据统计</el-dropdown-item>
                <!--<el-dropdown-item command="fontFamily" v-if="isAdmin">字体库</el-dropdown-item>-->
                <el-dropdown-item command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <projects-dialog v-model="projectDialogVal"></projects-dialog>
    </div>
</template>
<script>
    import projectsDialog from '../project/projects-dialog';
    import authService from '../../request/service/auth-service'
    import util from '@/util'
    export default {
        components: {projectsDialog},
        data() {
            return {
                projectDialogVal: false
            };
        },
        computed: {
            user() {
                return this.$store.state.app.loginUser;
            },
            isProjectUser() {
                 let isStudyCP =  this.$store.getters['app/isStudyCP'];
                 return this.$store.getters['app/isProjectUser'] && !isStudyCP;
            },
            isAdmin() {
                let isStudyCP =  this.$store.getters['app/isStudyCP'];
                return this.$store.getters['app/isAdmin'] && !isStudyCP;
            },
            isProjectAdmin() {
                return this.$store.getters['app/isProjectAdmin'];
            },
            isSYSAdmin() {
                return this.$store.getters['app/isSYSAdmin'];
            }
        },
        created(){
        },
        methods: {
            exec () {
               return {
                   logout: () => {
                       authService.logout().then(() => {
                           let user = {
                                email: '',
                                id: '',
                                mobile: '',
                                name: '',
                                projectApplyList: [],
                                projectItems: [],
                                role: '',
                                projectRoles: []
                           }
                            this.$store.commit('app/set_login_user', user);
                           let yktUrl = util.getYKTCache();
                           if(yktUrl){
                               util.clearYKTCache();
                               window.location.href = util.getYktUrl(yktUrl);
                           } else {
                               this.$router.push({path:'/home'});
                           }
                       }).catch((err) => {
                           console.log(err);
                       });
                   },
                   user: () => {
                       let projects = this.$store.state.app.adminProjects;
                       if (projects.length > 1) {
                           this.projectDialogVal = true;
                       } else if (projects.length == 1) {
                           this.$router.push(`/admin/userManagement?projectId=${projects[0].id}`);
                       }
                   },
                   project: () => {
                       this.$router.push('/project/apply');
                   },
                   admin: () =>{
                        if (this.isProjectAdmin) {
                          this.$router.push('/admin/tagsManage');
                        } else {
                          this.$router.push('/admin');
                        }
                   },
                   dataView: () => {
                       this.$router.push('/admin/dataView');
                   },
                 fontFamily: () => {
                   this.$router.push('/admin/fontFamily');
                 }
               }
            },
            onMenuClick(command) {
               let func = this.exec()[command];
               func();
            }
        }
    };
</script>